export const UNPAID_HOLIDAY = 'UNPAIDHOLIDAY';
export const EXCEPTIONAL_HOLIDAY = 'EXCEPTIONALHOLIDAY';
export const PAID_HOLIDAY= 'PAIDHOLIDAY';
export const SENIORITYHOLIDAY = 'SENIORITYHOLIDAY';
export const RTTHOLIDAY = 'RTTHOLIDAY';
export const EXCEPTIONALHOLIDAY = 'EXCEPTIONALHOLIDAY';
export const PAIDHOLIDAY = 'PAIDHOLIDAY';
export const CASUALLEAVE = 'CASUALLEAVE';



// WEBPACK FOOTER //
// ./src/app/model/commons/HolidayConstants.ts